/**
 * This class handles translating user inputs into the target language.
 */
howspace.components.translator = (() => {
    'use strict';

    let isEnabled = false;
    let targetLang = 'en';

    const callbacks = new Map();
    const getCallbackKey = (type, id, attr = '') => attr ? `${type}#${id}#${attr}` : `${type}#${id}`;
    const setCallback = (type, id, attr, callback) => callbacks.set(getCallbackKey(type, id, attr || ''), callback);
    const executeCallbacks = (elem) => {
        const myKey = getCallbackKey(elem.data('t9n-type'), elem.data('t9n-id'), elem.data('t9n-attr'));
        if (callbacks.has(myKey)) {
            callbacks.get(myKey)(elem);
        }
    };

    const handleElementTranslated = (elem) => {
        elem.removeClass('translating translation-animating waiting-for-translation').addClass('translated');
        executeCallbacks(elem);
        elem.trigger(howspace.components.translator.TRANSLATION_COMPLETED);
    };

    real.onTierReady(real.TIER_2, () => {
        real.events.on('translator:translation:completed', notification => {
            real.loop(notification.object.translations || {}, (targetText, translationId) => {
                $('[data-translation-id="' + translationId + '"]').each((_i, element) => {
                    element = $(element);
                    updateTranslatedElement(element, targetText);
                });
            });
        });

        real.events.on('translator:translation:failed', notification => {
            real.loop(notification.object.translation_ids || [], id => {
                const element = $('[data-translation-id="' + id + '"]');
                element.removeClass('translating waiting-for-translation').addClass('translatable-exception');
                element.find('.translation-loader').remove();
            });
        });
    });

    const getTranslatableSourceObjects = elems => {
        const sourceObjects = [];
        const translatableElements = [];
        elems.each(function () {
            const elem = $(this);
            if (elem.is('.translatable, .translatable-attr') && !elem.is('.translating, .translatable-exception, .translated')) {
                translatableElements.push(elem);
            }
            elem.find(':is(.translatable, .translatable-attr):not(.translating, .translatable-exception, .translated)').each(function () {
                translatableElements.push($(this));
            });
        });
        translatableElements.forEach((translatable) => {
            translatable = $(translatable);
            translatable.addClass('translating');
            const data = {
                id: translatable.data('t9n-id'),
                type: translatable.data('t9n-type')
            };
            if (translatable.data('t9n-attr')) {
                data.attr = translatable.data('t9n-attr');
            }

            // Store only unique objects.
            let alreadyCollected = false;
            for (const sourceObject of sourceObjects) {
                if (
                    sourceObject.id === data.id &&
                    sourceObject.type === data.type &&
                    (!data.attr || (data.attr && sourceObject.attr === data.attr))
                ) {
                    alreadyCollected = true;
                    break;
                }
            }
            if (!alreadyCollected) {
                sourceObjects.push(data);
            }
        });
        return sourceObjects;
    };

    const getSourceText = sourceObject => {
        let sourceText = '';
        getSourceElements(sourceObject).each(function () {
            const element = $(this);
            if (!element.is('.translated')) {
                if (element.hasClass('translatable-attr')) {
                    sourceText = element.attr(element.data('t9n-attr-name'));
                } else {
                    sourceText = element.html();
                }
                return false;
            }
        });
        return sourceText;
    };

    const getSourceElements = sourceObject => {
        const allowedDataAttrs = [
            'id',
            'type',
            'attr'
        ];
        // Convert all properties of the source object to a string and use it as a selector.
        let selector = '';
        real.loop(sourceObject, (value, key) => {
            if (allowedDataAttrs.indexOf(key) === -1) {
                return;
            }
            if (value === null) {
                return;
            }
            selector += '[data-t9n-' + key + '="' + value + '"]';
        });
        return $(selector);
    };

    const updateTranslatedElement = (element, targetText) => {
        if (!element.hasClass('translating') || element.hasClass('translated')) {
            // The element is not translating, or it's already translated, no need to translate again.
            return;
        }
        if (element.hasClass('translatable')) {
            // Animate the translation change in the UI.
            animateTranslationChange(element, targetText);
        }
        if (element.hasClass('translatable-attr')) {
            if (element.hasClass('tooltip')) {
                howspace.components.toolTip.update(element, targetText);
            } else {
                const attrName = element.data('t9n-attr-name');
                if (attrName.startsWith('data-')) {
                    const dataAttrName = attrName.substring('data-'.length);
                    element.dataAndAttr(dataAttrName, targetText);
                } else {
                    element.attr(element.data('t9n-attr-name'), targetText);
                }
            }
            // If we only translate attributes, call handleElementTranslated here,
            // otherwise it is handled by animateTranslationChange after animation finishes
            if (!element.hasClass('translatable')) {
                handleElementTranslated(element);
            }
        }
        if (element.hasClass('translatable-exception')) {
            element.removeClass('translatable-exception');
        }
    };

    const animateTranslationChange = (element, translatedContent) => {
        if (!element.hasClass('translation-animating') && element.hasClass('velocity-animating')) {
            // Wait for the previous animation to complete before starting a new one.
            element.one(howspace.animate.ANIMATION_COMPLETED, () => {
                animateTranslationChange(element, translatedContent);
            });
            return;
        }

        if (element.hasClass('translation-animating')) {
            return;
        }

        element.addClass('translation-animating');

        // Animate the translation change in the UI.
        if (element.is(':hidden')) {
            // The element is hidden, no need to animate, just update the translation immediately.
            element.html(translatedContent);
            element.find('.translation-loader').remove();
            handleElementTranslated(element);
            return;
        }

        const originalClasses = element[0].className;
        const originalStyles = element[0].style.cssText;

        const newElement = element.clone(true);
        newElement.html(translatedContent);
        newElement.find('.translation-loader').remove();
        element.before(newElement);
        const animProps = {
            height: newElement.outerHeight(),
            opacity: 0
        };
        newElement.hide();
        newElement.addClass('removing');

        if (element.is('.translatable-block')) {
            element.addClass('notransition').css('overflow', 'hidden');
        }

        howspace.animate(element, animProps, 300, () => {
            requestAnimationFrame(function () {
                newElement.remove();

                element.html(translatedContent);
                element.removeClass('translating waiting-for-translation').addClass('translated');
                element.find('.translation-loader').remove();

                howspace.animate(element, 'fadeIn', 300, () => {
                    element[0].className = originalClasses;
                    element[0].style = originalStyles;
                    handleElementTranslated(element);
                });
            });
        });
    };

    const getNotCachedSourceObjects = elem => {
        let sourceObjects = [];
        if (Array.isArray(elem)) {
            for (const loopElem of elem) {
                sourceObjects = sourceObjects.concat(getTranslatableSourceObjects(loopElem));
            }
        } else {
            sourceObjects = getTranslatableSourceObjects(elem);
        }

        const notCachedSourceObjects = [];
        for (const sourceObject of sourceObjects) {
            const sourceText = getSourceText(sourceObject);
            const targetText = cache.get(sourceObject.id, sourceText);
            if (targetText) {
                requestAnimationFrame(() => {
                    getSourceElements(sourceObject).each(function () {
                        updateTranslatedElement($(this), targetText);
                    });
                });
            } else {
                notCachedSourceObjects.push(sourceObject);
            }
        }
        return notCachedSourceObjects;
    };

    const handleTranslationResponse = (elem, response) => {
        real.loop(response.translations, (item) => {
            let selector = '[data-t9n-type=' + item.type + ']' + '[data-t9n-id=' + item.id + ']';
            if (item.attr) {
                selector += '[data-t9n-attr=' + item.attr + ']';
            }

            const translateElems = elem.findIncludingSelf(selector);
            translateElems.dataAndAttr('translation-id', item.translation.id);

            // Ready translation has been successfully generated, failed translation contains the original text.
            if (item.translation.state === 'ready' || item.translation.state === 'failed') {
                // Translation is ready.
                translateElems.each((_i, element) => {
                    element = $(element);
                    cache.set(item.id, getSourceText(item), item.translation.target_text);
                    updateTranslatedElement(element, item.translation.target_text);
                });
                return true;
            }

            // Translation is not ready.
            translateElems.each((_i, translateElem) => {
                translateElem = $(translateElem);
                if (translateElem.hasClass('waiting-for-translation')) {
                    // Element is already waiting for translation.
                    return true;
                }

                // Not yet waiting for translation, add the "translating" and "waiting-for-translation" classes.
                translateElem.addClass('waiting-for-translation');

                if (!translateElem.hasClass('translatable')) {
                    // Element does not have "translatable" class, most likely translating just an attribute.
                    return true;
                }

                // Translating some visible UI, add a loader for the duration of translating.
                translateElem.append('<span class="howspace-loader translation-loader ml-3" aria-hidden="true"></span>');
            });
        });
    };

    const cacheStorage = {};
    const cache = {
        'set': (id, sourceText, targetText) => {
            if (sourceText === null || sourceText === undefined) {
                return;
            }
            if (!cacheStorage[id]) {
                cacheStorage[id] = [];
            }

            cacheStorage[id].push({
                'sourceText': sourceText.trim(),
                'targetText': targetText
            });
        },
        'get': (id, sourceText) => {
            if (sourceText === null || sourceText === undefined) {
                return;
            }
            const trimmedText = sourceText.trim();
            if (trimmedText === '') {
                // Trimmed source text is empty, return empty string.
                return '';
            }

            if (!cacheStorage[id]) {
                // No cache for this id, return null.
                return null;
            }

            let result = null;
            real.loop(cacheStorage[id], item => {
                if (item.sourceText === trimmedText) {
                    result = item.targetText;
                    // We have a match, stop the loop.
                    return false;
                }
            });

            return result;
        }
    };

    return {
        TRANSLATION_COMPLETED: 'translation-completed',
        configure: (enabled, lang) => {
            isEnabled = enabled;
            targetLang = lang;
        },
        init: (elem) => {
            if (!isEnabled || targetLang === '') {
                // User translations are disabled or there is no target language to translate to.
                return;
            }

            if (elem.length === 0) {
                // No elements to translate.
                return;
            }

            const dataPayload = {
                target_lang: targetLang,
                source_objects: getNotCachedSourceObjects(elem)
            };

            if (dataPayload.source_objects.length === 0 || Object.keys(dataPayload.source_objects[0]).length === 0) {
                // All source objects are already cached.
                return;
            }

            real.ajax.json(real.baseUri + '/api/translator/translate-objects', {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: response => {
                    handleTranslationResponse(elem, response);
                }
            });
        },
        destroy: () => {
            // Translator doesn't need any destroy logic.
        },
        isEnabled: () => {
            return isEnabled;
        },
        getTargetLang: () => {
            if (isEnabled && targetLang !== '') {
                return targetLang;
            }
            return null;
        },
        setCallback: setCallback,
    };
})();
